<template>
    <div class="top-header">
        <Row :gutter="2">
            <Col span="8">
                <div class="top-logo">
                    <img src="../../public/img/logo.jpg" alt="">
                </div>
            </Col>
            <Col span="16">
                <div class="navigation">
                    <ul>
                        <li>
                            <router-link :to="{name: 'home'}" tag="a">首页</router-link>
                        </li>
                        <li v-on:mouseenter="showSubNav(2)" v-on:mouseleave="hiddenSubNav(2)">
                            <a v-bind:class="{ redBorder: surveyToggleStatus }">公司概况</a>
                            <dl>
                                <transition name="bounce1">
                                    <dd v-show="surveyToggleStatus">
                                        <router-link :to="{name: 'profile'}" tag="span">
                                            公司简介
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce2">
                                    <dd v-show="surveyToggleStatus">
                                        <router-link :to="{name: 'culture'}" tag="span">
                                            公司文化
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce3">
                                    <dd v-show="surveyToggleStatus">
                                        <router-link :to="{name: 'news'}" tag="span">
                                            新闻动态
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce4">
                                    <dd v-show="surveyToggleStatus">
                                        <router-link :to="{name: 'trends'}" tag="span">
                                            党建动态
                                        </router-link>
                                    </dd>
                                </transition>
                            </dl>
                        </li>
                        <li v-on:mouseenter="showSubNav(3)" v-on:mouseleave="hiddenSubNav(3)">
                            <a v-bind:class="{ redBorder: productToggleStatus }">产品中心</a>
                            <dl>
                                <transition name="bounce1">
                                    <dd v-show="productToggleStatus">
                                        <router-link :to="{name: 'product-category'}" tag="span">
                                            产品列表
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce2">
                                    <dd v-show="productToggleStatus">
                                        <router-link :to="{name: 'solution'}" tag="span">
                                            解决方案
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce3">
                                    <dd v-show="productToggleStatus">
                                        <router-link :to="{name: 'product-consult'}" tag="span">
                                            在线咨询
                                        </router-link>
                                    </dd>
                                </transition>
                            </dl>
                        </li>
                        <li v-on:mouseenter="showSubNav(4)" v-on:mouseleave="hiddenSubNav(4)">
                            <a v-bind:class="{ redBorder: marketingToggleStatus }">营销与服务</a>
                            <dl>
                                <transition name="bounce1">
                                    <dd v-show="marketingToggleStatus">
                                        <router-link :to="{name: 'outlet'}" tag="span">
                                            营销网络
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce2">
                                    <dd v-show="marketingToggleStatus">
                                        <router-link :to="{name: 'network'}" tag="span">
                                            服务网点
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce3">
                                    <dd v-show="marketingToggleStatus">
                                        <router-link :to="{name: 'overseas-market'}" tag="span">
                                            海外市场
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce4">
                                    <dd v-show="marketingToggleStatus">
                                        <router-link :to="{name: 'service'}" tag="span">
                                            服务承诺
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce5">
                                    <dd v-show="marketingToggleStatus">
                                        <router-link :to="{name: 'quality'}" tag="span">
                                            质量体系
                                        </router-link>
                                    </dd>
                                </transition>
                            </dl>
                        </li>
                        <li v-on:mouseenter="showSubNav(5)" v-on:mouseleave="hiddenSubNav(5)">
                            <a v-bind:class="{ redBorder: researchToggleStatus }">研发与制造</a>
                            <dl>
                                <transition name="bounce1">
                                    <dd v-show="researchToggleStatus">
                                        <router-link :to="{name: 'development'}" tag="span">
                                            研发能力
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce2">
                                    <dd v-show="researchToggleStatus">
                                        <router-link :to="{name: 'produce'}" tag="span">
                                            制造能力
                                        </router-link>
                                    </dd>
                                </transition>
                            </dl>
                        </li>
                        <li><a href="http://101.37.119.76:18899/dpcvs4.0/service/mepgk/mepgk_download.jsp" target="_blank">环保信息公开</a></li>
                        <li v-on:mouseenter="showSubNav(6)" v-on:mouseleave="hiddenSubNav(6)">
                            <a v-bind:class="{ redBorder: contactToggleStatus }">联系我们</a>
                            <dl>
                                <transition name="bounce1">
                                    <dd v-show="contactToggleStatus">
                                        <router-link :to="{name: 'contact-us'}" tag="span">
                                            联系方式
                                        </router-link>
                                    </dd>
                                </transition>
                                <transition name="bounce2">
                                    <dd v-show="contactToggleStatus">
                                        <router-link :to="{name: 'join-us'}" tag="span">
                                            招募英才
                                        </router-link>
                                    </dd>
                                </transition>
                            </dl>
                        </li>
                        <li class="english">
                            <a href="/car_en">
                                <span>ENGLISH</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: "TopHeader",
        data() {
          return {
              surveyToggleStatus: false,
              productToggleStatus: false,
              marketingToggleStatus: false,
              researchToggleStatus: false,
              contactToggleStatus: false
          }
        },
        methods: {
            showSubNav(type) {
                setTimeout(() => {
                    
                    switch (type) {
                        case 1:

                            break
                        case 2:
                            this.surveyToggleStatus = true
                            break
                        case 3:
                            this.productToggleStatus = true
                            break
                        case 4:
                            this.marketingToggleStatus = true
                            break
                        case 5:
                            this.researchToggleStatus = true
                            break
                        case 6:
                            this.contactToggleStatus = true
                            break
                    }
                }, 300)

            },
            hiddenSubNav(type) {
                setTimeout(() => {
                    switch (type) {
                        case 1:

                            break
                        case 2:
                            this.surveyToggleStatus = false
                            break
                        case 3:
                            this.productToggleStatus = false
                            break
                        case 4:
                            this.marketingToggleStatus = false
                            break
                        case 5:
                            this.researchToggleStatus = false
                            break
                        case 6:
                            this.contactToggleStatus = false
                            break
                    }

                }, 500)

            }
        }
    }
</script>

<style scoped lang="stylus">
    .top-header
        margin 0 auto
        width 1200px
        height 68px
        padding 0px
        background-color white
        .top-logo
            overflow hidden
            height 68px
            padding-top 6px
            text-align left
            img
                width 280px
        .navigation
            position absolute
            z-index 9999
            text-align left
            height 42px
            background-color white
            ul
                display block
                list-style-type none
                margin 0
                padding 0
                outline none
                background-color ghostwhite
                li
                    display block
                    float left
                    overflow hidden
                    position relative
                    a
                        display block
                        padding 26px 20px
                        height 68px
                        font-size 13px
                        color dimgrey
                        font-weight bold
                        border-bottom 3px solid white
                        transition:all 0.2s ease-in
                    .redBorder
                        color #E5001F
                        border-bottom 3px solid #E5001F
                    dl
                        display block
                        width 100%
                        text-align center
                        padding 0px
                        dd
                            background-color black
                            span
                                display block
                                padding 8px
                                cursor pointer
                                color white
                                transition: color .1s ease-in
                                &:hover
                                    color #E5001F
                        .bounce1-enter-active
                            animation bounce-in .1s
                        .bounce1-leave-active
                            animation bounce-in .5s reverse
                        .bounce2-enter-active
                            animation bounce-in .2s
                        .bounce2-leave-active
                            animation bounce-in .4s reverse
                        .bounce3-enter-active
                            animation bounce-in .3s
                        .bounce3-leave-active
                            animation bounce-in .3s reverse
                        .bounce4-enter-active
                            animation bounce-in .4s
                        .bounce4-leave-active
                            animation bounce-in .2s reverse
                        .bounce5-enter-active
                            animation bounce-in .5s
                        .bounce5-leave-active
                            animation bounce-in .1s reverse
                        @keyframes bounce-in {
                            from {
                                transform: scale(0)
                            }
                            to {
                                transform: scale(1)
                            }
                        }
                .english
                    a
                        padding-left 0px
                        span
                            font-size 12px
                            display block
                            color #E5001F
                            border 1px solid #E5001F
                            font-weight normal
                            padding 0px 6px
                            cursor pointer
</style>
